module.exports = __webpack_public_path__ + "img/race_900.704e1c63.png";